import styled from '@emotion/styled';
import { colors } from 'theme/colors';

const PageContent = styled.div`
  background: ${colors.blue50};
`;

const WizardPageContent = styled.div`
  background: ${colors.white};
`;

const PageWrapper = styled.div`
  display: flex;
  min-height: calc(100vh - 96px);
  flex-direction: column;
  padding: 40px 64px;
  background: ${colors.blue50};
  margin: auto;
`;

export { PageWrapper, PageContent, WizardPageContent };
